export default "__VITE_ASSET__CFGFHHLy__"